import React from 'react';
import { View, ActivityIndicator, Platform } from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';

export const Spinner = ({
	isOverlay = false,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={isOverlay ? styles.overlay : styles.container}>
			<ActivityIndicator
				color={styles.indicator.color}
				size="large"
			/>
		</View>
	);
};

const createStyles = ({ spinnerBg, ui: { colors } }) => ({
	container: {
		flex: 1,
		height: '100%',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: colors.canvas,
	},
	overlay: {
		position: 'absolute',
		height: '100%',
		width: '100%',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 999,
		backgroundColor: spinnerBg,
		display: 'flex',
		justifyContent: 'center',
		elevation: (Platform.OS === 'android') ? 100 : 0,
	},
	indicator: {
		color: colors.accent,
	},
});

